<div class="assignement">
    <div><b>[{{assign().assignement.afdeling}}]</b> {{assign().assignement.type}}</div>
    <div>{{assign().assignement.omschrijving}}</div>
    <div>{{this.rangedKanaalLabel(assign().rangedKnaal)}}</div>
</div>
